<template>
  <div class="container int-container">
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{ $t('lbl.dbBroker.pageHeader') }}</v-toolbar-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col class="pb-0 pt-0 mt-0" cols="12" lg="5" md="5">
        <v-row class="custom-form-control custom-figma-1 mb-0">
          <v-col cols="12" class="pt-0 pb-0">
            <v-row>
              <v-col
                class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
                cols="12"
                lg="12"
                md="12"
              >
                <v-row>
                  <v-col cols="12" lg="12" md="12" class="pt-0 pb-0 mb-0 arrow-btn-custom">
                    <div class="d-inline-flex">
                      <v-btn
                        v-if="$auth.manage"
                        class="btn-width-1 btn btn-top btn-search"
                        color="primary"
                        @click="openAddDbBroker"
                      >
                        <v-icon x-small class="mr-2">fa fa-plus</v-icon>
                        {{ $t('btn.common.add') }}
                      </v-btn>
                      <v-text-field
                        v-model="searchGroup"
                        :label="$t('lbl.common.conditionSearch.findbyDBBroker')"
                        class="custom-selectbox find-group-code pl-2"
                        dense
                        filled
                      ></v-text-field>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="code-table-hidden-div"></v-row>
        <v-row>
          <v-col cols="12" lg="12" md="12" class="pt-0 pb-0">
            <v-data-table
              :search="searchGroup"
              :headers="SummaryList.headers"
              :hide-default-footer="true"
              :fixed-header="true"
              :items="dbBrokerData"
              :sort-desc="true"
              :height="tableHeight"
              :class="[
                'list-table code-table srm-list-table custom-border-table',
                dbBrokerData.length > 0 ? '' : 'custom-border-table-not-data',
              ]"
              item-key="ROWID"
              pb-2
              disable-pagination
              sort-by="DBBRK_UPD_DT"
              @current-items="currentGroupItems"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="(item, index) in items"
                    :key="item.ROWID"
                    @click="onClickCodeGroup(item)"
                    :class="[
                      selectedRowGroup == item.DBBRK_ID || (selectedRowGroup == '' && index == 0)
                        ? 'selected_row'
                        : '',
                    ]"
                  >
                    <td class="col-codegroup">{{ item.DBBRK_NM }}</td>
                    <td class="text-center">{{ item.DBBRK_UPD_DT }}</td>
                    <td>{{ item.DBBRK_UPD_USR }}</td>
                    <td class="text-center">
                      <div class="d-inline-flex">
                        <v-btn
                          x-small
                          text
                          icon
                          @click.stop="openModifyDBBroker(item)"
                          :disabled="!$auth.manage"
                        >
                          <icon-svg iconName="edit" :disabled="!$auth.manage" />
                        </v-btn>
                      </div>
                      <v-tooltip top :disabled="item.numOfUse == 0">
                        <template v-slot:activator="{ on }">
                          <div v-on="on" class="btn-tooltip">
                            <v-btn
                              small
                              text
                              icon
                              @click="deleteItem(item)"
                              :disabled="!$auth.manage || item.numOfUse > 0"
                            >
                              <icon-svg
                                :disabled="!$auth.manage || item.numOfUse > 0"
                                iconName="delete"
                              />
                            </v-btn>
                          </div>
                        </template>
                        <span v-html="$t('lbl.processSetup.dbBrkInUseWF')"></span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="pb-0 pt-0 mt-0" cols="12" lg="7" md="7">
        <v-row
          class="custom-form-control custom-form-control-type-2 code-data-section custom-figma-1 mb-0"
        >
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
            lg="12"
            md="12"
          >
            <v-row>
              <v-col cols="3" class="pt-0 pb-0">
                <v-text-field
                  v-model="queryPoolItems.QR_NM"
                  :label="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.queryName')"
                  @keyup.enter="getQueryPoolList()"
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="queryPoolItems.QR_DB"
                  :items="searchNameDBList"
                  :label="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.dbName')"
                  @change="getQueryPoolList()"
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="2" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="queryPoolItems.QR_TP"
                  :items="searchTypeDBList"
                  :label="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.type')"
                  @change="getQueryPoolList()"
                  dense
                  filled
                ></v-autocomplete>
              </v-col>
              <v-col cols="5" class="pt-0 pb-0">
                <v-text-field
                  v-model="queryPoolItems.QR_TXT"
                  :label="$t('lbl.dbBroker.addDBBrokerDialog.conditionSearch.queryText')"
                  @keyup.enter="getQueryPoolList()"
                  dense
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="btn-form-control code-tbl-btn-control">
          <v-col cols="12" class="pt-0 pb-0 pl-0">
            <v-row>
              <v-col cols="12" lg="8" md="8" class="pt-0 pb-0 pr-0">
                <div class="pl-0 pt-0 pb-0 d-inline-flex code-table-section">
                  <v-checkbox
                    v-model="checkbox"
                    @change="getQueryPoolList()"
                    class="mt-0 pt-0"
                    hide-details
                    dense
                    solo
                  ></v-checkbox>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex code-table-section">
                  <span class="all-code-label mr-5">{{ $t('lbl.dbBroker.checkboxLabel') }}</span>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex code-table-section">
                  <span class="code-table-label">{{ $t('lbl.dbBroker.codeLabelInfo') }}</span>
                </div>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0 text-right">
                <v-btn class="btn btn-top btn-add" @click="openQueryPoolDialog">{{
                  $t('btn.dbBroker.queryPool')
                }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pb-0 pl-0">
            <v-row no-gutters>
              <system-progress
                :sysloading="isLoading"
                :sysloadingTitle="sysloadingTitle"
              ></system-progress>
              <v-col cols="12" lg="12" md="12" class="code-data-range">
                <v-data-table
                  :headers="QueryPool.headers"
                  :items="dataPoolList"
                  :fixed-header="true"
                  :footer-props="{ showFirstLastPage: true }"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  :height="tableHeightDataPool"
                  :class="[
                    'list-table code-table srm-list-table custom-border-table',
                    dataPoolList.length > 0 ? '' : 'custom-border-table-not-data',
                  ]"
                  hide-default-footer
                  no-data-text="No matching records found"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                        :class="[selectedRowPool == item.QR_ID ? 'selected_row' : '']"
                      >
                        <td class="text-center">
                          {{ (page - 1) * itemsPerPage + index + 1 }}
                        </td>
                        <td>{{ item.QR_NM }}</td>
                        <td class="custom-type-db">{{ item.QR_DB }}</td>
                        <td class="custom-type-db">{{ item.QR_TP }}</td>
                        <td class="custom-trim-text">{{ item.QR_TXT }}</td>
                        <td class="text-center">
                          <icon-svg
                            @click.stop
                            style="margin: 0 auto"
                            size="26"
                            iconName="execution"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-show="dataPoolList.length > 0" class="custom-pagination-figma-v3-last ml-2">
              <v-col class="page-control-content page-control-bg transaction-pagi">
                <v-row>
                  <v-col lg="12" md="12">
                    <v-row>
                      <v-col class="page-control-bg text-left pa-0" cols="6">
                        <div class="custom-pagi-selectbox">
                          <v-select
                            v-model="itemsPerPage"
                            :items="rowPerPage"
                            @change="getQueryPoolList()"
                            class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox pt-2"
                            hide-details
                            dense
                            solo
                          ></v-select>
                        </div>
                      </v-col>
                      <v-col class="page-control-bg text-right pa-0" cols="6">
                        <div class="page-showing">
                          <v-label>
                            {{ itemsPerPage * (page - 1) + 1 }} ~
                            {{
                              dataPoolList.length - itemsPerPage * page > 0
                                ? itemsPerPage * page
                                : dataPoolList.length
                            }}
                            of {{ dataPoolList.length }}
                          </v-label>
                        </div>
                        <button
                          type="button"
                          @click="
                            page = 1;
                            getQueryPoolList(false);
                          "
                          :class="[
                            'custom-btn-first-last-paging',
                            page == 1 ? ' v-pagination__navigation--disabled' : '',
                          ]"
                        >
                          <div class="ml-2 pr-2 d-inline">
                            <span><i class="fa fa-sm fa-step-backward"></i></span>
                          </div>
                        </button>
                        <button
                          type="button"
                          @click="changePageByTextbox(-1)"
                          :class="[
                            'mr-3 custom-btn-first-last-paging',
                            page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                          ]"
                        >
                          <div class="ml-2 pr-2 d-inline">
                            <span><i class="fa fa-lg fa-caret-left"></i></span>
                          </div>
                        </button>
                        <v-text-field
                          v-model="pageEnter"
                          hide-details
                          dense
                          solo
                          class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                          @keyup.enter="changePageByTextbox(0)"
                        ></v-text-field
                        ><label>/ {{ pageCount }}</label>
                        <button
                          type="button"
                          @click="changePageByTextbox(1)"
                          :class="[
                            'ml-3 custom-btn-first-last-paging',
                            page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                          ]"
                        >
                          <div class="mr-2 pl-2 d-inline">
                            <span><i class="fa fa-lg fa-caret-right"></i></span>
                          </div>
                        </button>
                        <button
                          type="button"
                          @click="
                            page = pageCount;
                            getQueryPoolList(false);
                          "
                          :class="[
                            'custom-btn-first-last-paging',
                            page == pageCount ? ' v-pagination__navigation--disabled' : '',
                          ]"
                        >
                          <div class="mr-2 pl-2 d-inline">
                            <span><i class="fa fa-sm fa-step-forward"></i></span>
                          </div>
                        </button>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.dbBroker.deleteConfirm')"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDeleteFile($event)"
      :showCancel="true"
    ></dialogWindow>
    <dialogWindow
      ref="validateAddCode"
      size="max"
      title="warning"
      :detail="$t('msg.dbBroker.noSelectItem')"
      color="validation"
      :showCancel="false"
    ></dialogWindow>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <addDBBroker
        v-if="dialog.type == 'addDBBroker'"
        class="maplist-layout-dialog add-code-dialog"
        :id="dialog.id"
        :ref="'dialog-' + dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :dbNames="searchNameDBList"
        :types="searchTypeDBList"
        @refreshData="getGroupList($event)"
      ></addDBBroker>
      <queryPool
        v-if="dialog.type == 'QueryPool'"
        class="maplist-layout-dialog mapbuilder-scanner-list codetable-list"
        :id="dialog.id"
        ref="CodeDataPool"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @refreshData="getQueryPoolList"
        :typeDBList="typeDBList"
        :nameDBList="nameDBList"
        :searchTypeDBList="searchTypeDBList"
        :searchNameDBList="searchNameDBList"
      ></queryPool>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import $ from 'jquery';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import addDBBroker from '@/vue-caas/views/dbbroker/AddDBBroker.vue';
import queryPool from '@/vue-caas/views/dbbroker/QueryPool.vue';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    dialogWindow,
    addDBBroker,
    queryPool,
    SystemProgress,
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },
  computed: {
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },

  data() {
    return {
      page: 1,
      pageCount: 1,
      itemsPerPage: 100,
      pageEnter: 1, // 2021.11.26 203728 SPKA-274 modify paging
      tableHeight: '',
      tableHeightDataPool: '',
      rowPerPage: [
        { value: 100, text: 'Show 100' },
        { value: 200, text: 'Show 200' },
        { value: 500, text: 'Show 500' },
      ],
      listPage: [{ value: 1, text: 'Page 1' }],
      isCreated: false,
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      checkbox: false,
      selectedRowGroup: '',
      selectedRowGroupData: '',
      selectedRowPool: '',
      dataPoolList: [],
      searchGroup: '',
      deleteData: '',
      deleteDataName: '',
      dbBrokerData: [],
      SummaryList: {
        headers: [
          {
            text: this.$t('tbl.dbBroker.dbList.db'),
            value: 'DBBRK_NM',
            align: 'center',
            width: '220px',
          },
          {
            text: this.$t('tbl.dbBroker.dbList.lastUpdate'),
            value: 'DBBRK_UPD_DT',
            align: 'center',
            width: '180px',
          },
          {
            text: this.$t('tbl.dbBroker.dbList.updateUser'),
            value: 'DBBRK_UPD_USR',
            align: 'center',
          },
          {
            text: this.$t('tbl.dbBroker.dbList.manager'),
            value: '',
            align: 'center',
            sortable: false,
            width: '100px',
          },
        ],
      },
      QueryPool: {
        headers: [
          {
            text: this.$t('tbl.dbBroker.queryPool.no'),
            value: 'ROWID',
            align: 'center',
            sortable: false,
            width: '75px',
          },
          {
            text: this.$t('tbl.dbBroker.queryPool.queryName'),
            value: 'QR_NM',
            width: '120px',
            align: 'center',
          },
          {
            text: this.$t('tbl.dbBroker.queryPool.dbName'),
            value: 'QR_DB',
            width: '120px',
            align: 'center',
          },
          {
            text: this.$t('tbl.dbBroker.queryPool.type'),
            value: 'QR_TP',
            width: '90px',
            align: 'center',
          },
          {
            text: this.$t('tbl.dbBroker.queryPool.queryText'),
            value: 'QR_TXT',
            align: 'center',
          },
          {
            text: this.$t('tbl.dbBroker.queryPool.testing'),
            value: '',
            align: 'center',
            sortable: false,
            width: '75px',
          },
        ],
      },
      groupListSearchItems: {
        CUST_ID: '',
        OWNR_CUST_ID: '',
      },
      queryPoolItems: {
        QR_NM: '',
        QR_DB: null,
        QR_TP: null,
        QR_TXT: '',
        R_FROM: 1,
        R_TO: this.itemsPerPage,
        SORT: 'UPDATE',
      },
      deleteItems: {
        DBBRK_ID: '',
      },
      isLoading: false,
      typeDBList: [],
      nameDBList: [],
      searchTypeDBList: [],
      searchNameDBList: [],
      codeDataPool: [],
      currentGroup: '',
    };
  },
  watch: {
    pageCount(newVal, oldVal) {
      if (newVal != oldVal) {
        this.listPage = [];
        for (let i = 1; i <= newVal; i++) {
          this.listPage.push({ value: i, text: 'Page ' + i });
        }
      }
    },
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.getQueryPoolList(false);
    },
    currentGroupItems: function(value) {
      if (this.checkbox) return;
      if (typeof value !== 'undefined' && value.length > 0) {
        this.currentGroup = value;
        let check = value.includes(this.selectedRowGroupData);
        if (!check) this.dataPoolList = [];
        else this.dataPoolList = this.codeDataPool;
      } else {
        this.dataPoolList = [];
      }
    },
    getGroupList() {
      this.groupListSearchItems.CUST_ID = this.$cookies.get('comp-id');
      this.groupListSearchItems.OWNR_CUST_ID = this.$cookies.get('ownr-id');
      this.$store.dispatch('getDbBrokerList', this.queryPoolItems).then((res) => {
        this.dbBrokerData = res;
        let count = res.length;
        if (typeof res !== 'undefined' && count > 0) {
          this.selectedRowGroup = res[count - 1].DBBRK_ID;
          this.selectedRowGroupData = res[count - 1];
          this.getQueryPoolList();
        }
      });
    },
    getQueryPoolList(resetPage = true) {
      this.isLoading = true;
      if (resetPage) this.page = 1;
      this.queryPoolItems.CUST_ID = this.$cookies.get('comp-id');
      this.queryPoolItems.OWNR_CUST_ID = this.$cookies.get('ownr-id');
      this.queryPoolItems.DBBRK_ID = this.checkbox ? '' : this.selectedRowGroup;

      this.queryPoolItems.R_FROM = this.itemsPerPage * (this.page - 1) + 1;
      this.queryPoolItems.R_TO = this.itemsPerPage * this.page;

      this.$store
        .dispatch('getQueryPoolList', this.queryPoolItems)
        .then((res) => {
          console.log('--------- Finished to process ----------');
          this.pageCount = Math.floor(res.queryTotal / this.itemsPerPage);
          if (this.itemsPerPage * this.pageCount !== res.queryTotal) this.pageCount += 1;

          this.dataPoolList = res.queryPoolList;
          this.codeDataPool = res.queryPoolList;

          res.queryPoolList.map((e) => {
            let index = this.typeDBList.findIndex((r) => r.value === e.QR_TP);
            if (index > -1) e.QR_TP = this.typeDBList[index].text;
          });

          if (!this.checkbox && this.searchGroup != '') this.currentGroupItems(this.currentGroup);
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    openQueryPoolDialog(codeCtg) {
      let type = 'QueryPool';
      let item = {
        ROWID: 0,
        codeCtg: this.codeCtg,
      };
      let indexArrDialog = this.findDialog('QueryPool_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    onClickCodeGroup(item) {
      this.checkbox = false;
      this.selectedRowGroup = item.DBBRK_ID;
      this.selectedRowGroupData = item;
      if (item.DBBRK_ID != undefined && item.DBBRK_ID != null) this.getQueryPoolList();
    },
    deleteItem(item) {
      this.deleteData = item.DBBRK_ID;
      this.deleteDataName = item.DBBRK_NM;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    okDeleteFile(item) {
      this.deleteItems.DBBRK_ID = item;
      this.$store.dispatch('deleteDbBroker', this.deleteItems).then((res) => {
        this.getGroupList();
      });
    },
    openAddDbBroker() {
      let type = 'addDBBroker';
      let item = {
        ROWID: 0,
        action: 'add',
        selectedRow: this.selectedRowGroupData,
      };
      let indexArrDialog = this.findDialog('addDBBroker_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openModifyDBBroker(rowItem) {
      let type = 'addDBBroker';
      let item = {
        ROWID: 0,
        action: 'modify',
        selectedRow: rowItem,
      };
      let indexArrDialog = this.findDialog('addDBBroker_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
  },
  created() {
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P08' }).then(() => {
      this.$store.getters['caascommon/comCdList'].map((e) => {
        this.typeDBList.push({ text: e.text, value: e.value });
        this.searchTypeDBList.push({ text: e.text, value: e.value });
      });
      this.searchTypeDBList.unshift({
        text: this.$t('lbl.common.conditionSearch.all'),
        value: '',
      });
    });
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'P07' }).then(() => {
      this.$store.getters['caascommon/comCdList'].map((e) => {
        this.nameDBList.push({ text: e.text, value: e.value });
        this.searchNameDBList.push({ text: e.text, value: e.value });
      });
      this.searchNameDBList.unshift({
        text: this.$t('lbl.common.conditionSearch.all'),
        value: '',
      });
    });
    this.getGroupList();
    this.isCreated = true;
  },

  updated: function() {
    let self = this;
    let arrClassMinus = [];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 35 + 'px';
      self.tableHeightDataPool = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 35 + 'px';
      self.tableHeightDataPool = h1 + 'px';
    });
  },
};
</script>

<style>
.find-group-code.custom-selectbox .v-input__slot {
  width: 260px;
}
.find-table-code.custom-selectbox .v-input__slot {
  width: 200px;
}
.code-table-label {
  color: #d03144;
  font-size: 14px;
  font-weight: bold;
  line-height: 30px;
}
.all-code-label {
  color: #bbbbbb;
  margin-left: 0;
  font-size: 14px;
  font-weight: bold;
  line-height: 30px;
}
.code-table-section .v-input__control,
.code-table-section .v-input__control .v-input__slot {
  height: 30px;
}
.code-table-section .v-input__control .v-input__slot label {
  font-size: 14px;
}
.theme--dark .code-table.v-data-table tbody tr.selected_row {
  background: #243645 !important;
}
.theme--light .code-table.v-data-table tbody tr.selected_row {
  background: #eaf1f8 !important;
}
.code-table .fa-pen:hover,
.code-table .fa-trash-alt:hover {
  color: #0082ba;
}
.maplist-layout-dialog.add-code-dialog {
  width: 1405px !important;
  height: auto !important;
}
.code-modify-icon {
  margin-right: 10px;
}

.code-table-hidden-div {
  height: 32px;
  margin-bottom: 5px;
}
.code-data-range {
  padding-left: 15px !important;
}
#page-count-custom.flat-table-pagination .v-pagination__navigation {
  width: 70px !important;
  height: 27px !important;
  margin-right: 0px;
  margin-left: 8px;
  margin-top: 7px;
}
.custom-trim-text {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.custom-type-db {
  text-transform: lowercase !important;
}
.custom-type-db::first-line {
  text-transform: capitalize !important;
}
.comm-header-col.custom-figma-1.data-query-section .find-group-code label {
  width: 170px !important;
}
</style>
